// cSpell:ignore javascripts
import 'bootstrap-sass/assets/javascripts/bootstrap';
import './i18next';
import Modal from 'react-modal';
import RootContainer from '../../public/containers/RootContainer';

Modal.setAppElement('#conversations-app' as unknown as HTMLElement);

export { RootContainer as Main };
